module.exports = __webpack_public_path__ + "static/media/talleresHD.67d7c768.mp4";